exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-autocomplete-input-token {\r\n  padding: 0px;\r\n}\r\n.ui-autocomplete-multiple-container {\r\n  width: 100%;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/node_modules/css-loader?{"sourceMap":false,"import":false}!J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/primeng/autocomplete/css/primeng.autocomplete.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/primeng/autocomplete/css/primeng.autocomplete.css
// module chunks = styles